import React from 'react';
import PropTypes from 'prop-types';
import css from './TeamMember.css';
import Title from 'common/Title';

export default class TeamMember extends React.Component {

  get avatar() {
    if ( this.props.photoURL === null ) return null;
    return (
      <div
        className={css['avatar']}
        style={{backgroundImage: `url(${this.props.photoURL})`}}
      />
    );
  }

  render() {
    return (
      <div>
        <Title text="Team Member" />
      	<div className={css['row-container']}>
          {this.avatar}
          <div className={css['info-block']}>
            <div data-role="reviewAppointmentContact">{this.props.name}</div>
            <div>{this.props.title}</div>
          </div>
        </div>
      </div>
    );
  }
}

TeamMember.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  photoURL: PropTypes.string
};
